import DOMHelper from "./DOMIsReady";

export default class ProductListHelper{
  
  static promise: Promise<string> = null;
  

  static GetAllProductKeys(): Promise<string>{
    
    return this.promise || (this.promise = new Promise((resolve, reject) => {
      try{
        DOMHelper.docReady(() => {
          const listOfProductKeys: Array<string> = [];
          
          const listOfProductKeysElements = document.querySelectorAll('[data-product-key-clean]');
          listOfProductKeysElements.forEach(x => listOfProductKeys.push(x.getAttribute('data-product-key-clean')));
          
          // console.debug(listOfProductKeys);
          if(listOfProductKeys){
            //only allow a max of 100 products - to avoid API failure 
            let unique = new Set(listOfProductKeys.slice(0, 30));
            const list = Array.from(unique).join(';');
            resolve(list);
          }
        });
        
      }catch(err){
        
      }
    }));
  }



}

